module.exports = __webpack_public_path__ + "sentry-aw-snap.afe2fd59ee133fc3f94f5b7080faf07d.svg";